import { useState } from "react";
import { useParams } from "react-router-dom";

//Bootstrap
import { Row, Col, Button } from "react-bootstrap";

//API calls
import { useGetOtherPartners } from "../../../../services/ProjectDetails/partnerskeOrganizacijeAPI";

//components
import OstaliPartnerjiCards from "./OstaliPartnerjiCards";
import AddPartnerToProjectForm from "./AddPartnerToProjectForm";

//Auth
import RoleGuard from "../../../../auth/RoleGuard";
import { MODULES, ROLE_GROUPS } from "../../../../auth/roles";

//Context
import { useProjectDetailsContext } from "../../../../context/ProjectDetailsContext";

const OstaliPartnerji = () => {
  const { id } = useParams();
  const {
    data: otherPartners = [],
    isLoading,
    isError,
    error,
  } = useGetOtherPartners(id);
  const { project } = useProjectDetailsContext();

  const [isAdding, setIsAdding] = useState(false);

  const handleAddPartnerClick = () => {
    setIsAdding(!isAdding);
  };

  if (isLoading) {
    return (
      <div className="mb-3 mt-3">
        <h6 className="form-section-heading">Ostali partnerji</h6>
        <p>Nalaganje...</p>
      </div>
    );
  }

  if (isError) {
    const hasNoPermission = error?.status === 403;

    return (
      <Row>
        <Col md={12}>
          <Row className="align-items-center mb-2">
            <Col md={6}>
              <h6 className="form-section-heading mb-0">Ostali partnerji</h6>
            </Col>
            <Col md={6} className="d-flex justify-content-end">
              {!hasNoPermission && !isAdding && (
                <RoleGuard
                  moduleKey={MODULES.PROJEKTI}
                  roles={ROLE_GROUPS.EDITORS_AND_SKRBNIK}
                  vodilnaClanicaProjektaID={project?.clanicaID}
                >
                  <Button
                    variant="outline-primary border-0"
                    size="sm"
                    onClick={handleAddPartnerClick}
                  >
                    Dodaj partnerja na projekt
                  </Button>
                </RoleGuard>
              )}
            </Col>
          </Row>

          {hasNoPermission && (
            <p className="text-muted mb-0">
              Nimate pravic za ogled ostalih partnerjev na tem projektu.
            </p>
          )}

          {!hasNoPermission && isAdding && (
            <AddPartnerToProjectForm setIsAdding={setIsAdding} />
          )}

          {!hasNoPermission && !isAdding && (
            <p className="text-muted mb-0">
              Ostali partnerji projekta še niso vneseni.
            </p>
          )}
        </Col>
      </Row>
    );
  }

  return (
    <Row>
      <Col md={12}>
        <Row className="align-items-center mb-2">
          <Col md={6}>
            <h6 className="form-section-heading mb-0">Ostali partnerji</h6>
          </Col>
          <Col md={6} className="d-flex justify-content-end">
            {!isAdding && (
              <RoleGuard
                moduleKey={MODULES.PROJEKTI}
                roles={ROLE_GROUPS.EDITORS_AND_SKRBNIK}
                vodilnaClanicaProjektaID={project?.clanicaID}
              >
                <Button
                  variant="outline-primary border-0"
                  size="sm"
                  onClick={handleAddPartnerClick}
                >
                  Dodaj partnerja na projekt
                </Button>
              </RoleGuard>
            )}
          </Col>
        </Row>
        {isAdding && <AddPartnerToProjectForm setIsAdding={setIsAdding} />}
        {!isAdding && otherPartners.length === 0 && (
          <p className="text-muted mb-0">Ni vnesenih ostalih partnerjev.</p>
        )}
        {!isAdding && otherPartners.length > 0 && (
          <OstaliPartnerjiCards otherPartners={otherPartners} />
        )}
      </Col>
    </Row>
  );
};

export default OstaliPartnerji;
